import angular from 'angular'
import { invoiceAnalysis } from 'redevConfig'
const list = (invoiceAnalysis && invoiceAnalysis.list) || ''

const invoiceAnalysisList = list ? require(`redevelopment/statistics/invoiceAnalysis/${list.templateName}`) : require('./view/invoiceAnalysis.html')
const invoiceAnalysisListCtrl = list ? require(`redevelopment/statistics/invoiceAnalysis/${list.controllerName}`) : require('./invoiceAnalysisCtrl.js')
export default angular
    .module('statistics.chartAnalysis.invoiceAnalysis', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.chartAnalysis.invoiceAnalysis', {
            url: '/invoiceAnalysis',
            abstract: true,
            template: '<div ui-view></div>',
            title: '开票分析',
            default: 'statistics.chartAnalysis.invoiceAnalysis.list',
        })
        $stateProvider.state('statistics.chartAnalysis.invoiceAnalysis.list', {
            url: '/list',
            template: invoiceAnalysisList,
            controller: 'invoiceAnalysisListCtrl',

        })
    }])
    .controller('invoiceAnalysisListCtrl', invoiceAnalysisListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/invoiceAnalysis/index.js